import {Link} from 'react-router';

import {mediaGalleryImageT} from '@/lib/types/media.types';

import {LoadingSpinningLogoComponent} from './loadingSpinningLogoComponent';

export const ImageGalleryComponent = ({
  images,
  actions,
  isLoading,
  error,
}: {
  images: mediaGalleryImageT[];
  actions?: {icon: string; handler?: () => void; link?: string}[];
  isLoading?: boolean;
  error?: string;
}) => {
  if (isLoading) {
    return (
      <div className="w-full flex-1">
        <LoadingSpinningLogoComponent />
      </div>
    );
  }

  return (
    <div className="w-full px-4">
      {/* Display a message if no images are found */}
      {images.length === 0 && !isLoading && (
        <div className="w-full text-center">
          <h3 className="text-center text-gray-500">No images found</h3>
        </div>
      )}

      {/* Display an error message if there is an error */}
      {error && (
        <div className="w-full text-center">
          <h3 className="text-red-500 text-center">{error}</h3>
        </div>
      )}

      {/* Display the images */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {images.map((idx: mediaGalleryImageT) => (
          <div key={idx.id} className="w-full">
            <div className="box product-card !m-0 p-0">
              <div className="box-body">
                <div className="product-image">
                  <img src={idx.url} className="h-auto w-full rounded-md object-cover" alt={idx.alt} />
                </div>
                <div className="product-icons">
                  {actions?.map(({icon, handler, link}, index) => (
                    <Link key={index} aria-label="anchor" to={link || '#'} className="view" onClick={handler}>
                      <i className={icon}></i>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
